
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'RemediationModalManual',
  props: {
    identifier: {
      type: String,
      required: true
    },
    packageName: {
      type: String,
      required: true
    },
    packageVersion: {
      type: String,
      required: true
    },
    fixedVersions: {
      type: Array as PropType<string[]>,
      default: []
    }
  }
})
